<template lang="pug">
  div.wrap-item-tool-header
    div.tool-header-content.f.flex-between
      div.tools.f
        div(v-for="item in tools"
          @click="onToolIcon(item)"
          :class="{'active': item.type == currentTool}").tool-icon.f.fh.cursor-pointer
          v-icon(:size="item.size"
            :color="(item.type == currentTool) ? pallete.$primary_bg_color : '#fff'") {{item.icon}}
      div.tool-prop
        div.widget.f.fm
          div(v-if="currentTool == 'text'").selector.f.fm.mr12
            select(ref="fontWeight" v-model="fontFamily").fz14.mr2.pr20.cursor-pointer
              option(v-for="family in ['Yu Gothic', 'Arial', 'MS PGothic', 'MS PMincho']") {{family}}
            div.wrap-icon
              v-icon(size="20px") mdi-menu-down
          div(v-if="currentTool == 'text'").selector.f.fm.mr12
            select(ref="fontWeight" v-model="fontWeight").fz14.mr2.pr20.cursor-pointer
              option(v-for="weight in ['lighter', 'normal', 'bold']") {{weight}}
            div.wrap-icon
              v-icon(size="20px") mdi-menu-down
          div(v-if="currentTool == 'text'").selector.f.fm.mr12
            select(ref="fontSelect" v-model="fontSize").fz14.mr2.pr20.cursor-pointer
              option(v-for="num in [6, 8, 10, 12, 14, 16, 18, 20, 22, 24]") {{num}}
            div.wrap-icon
              v-icon(size="20px") mdi-menu-down
          div(v-if="currentTool == 'text'").wrap-color-picker.mr12
            v-menu(offset-y)
              template(v-slot:activator="{ on }")
                v-badge(:color="color" dot offset-x="6px" offset-y="6px")
                  v-icon(v-on="on" size="20px") mdi-format-color-text
                //- div(v-on="on")
              template
                div.picker
                  v-color-picker(v-model="color"
                    :swatches="swatches"
                    hide-canvas hide-inputs
                    hide-mode-switch hide-sliders
                    show-swatches swatches-max-height="300px")
          div(v-if="currentTool == 'text'").wrap-color-picker.mr12
            v-menu(offset-y)
              template(v-slot:activator="{ on }")
                v-badge(:color="backgroundColor" dot offset-x="6px" offset-y="6px")
                  v-icon(v-on="on" size="20px") mdi-format-color-fill
              template
                div.picker
                  v-color-picker(v-model="backgroundColor"
                    :swatches="bgSwatches"
                    hide-canvas hide-inputs
                    hide-mode-switch hide-sliders
                    show-swatches swatches-max-height="300px")
          //- div(v-if="currentTool == 'text' || currentTool == 'image'").wrap-animation-selector
            v-menu(offset-y)
              template(v-slot:activator="{ on }")
                div(:class="`doodle-animation-${currentAnimation}`").wrap-current-animation.pb4
                  v-icon(v-on="on" size="20px") mdi-alpha-a-box
              template
                div.doodle-animation-selector.py4
                  div(v-for="item in animations"
                    :class="`doodle-animation-${item}`").wrap-icon.mb8
                    v-icon(@click="currentAnimation = item") mdi-alpha-a-box
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-tool-header {
  position: relative;
  width: 100%;
  height: 32px;
  border-bottom: $basic_border;
  z-index: 101;
  background: $primary_bg_color;
  .tool-header-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $slide_width_percent;
    .tools {
      .tool-icon {
        width: 32px;
        height: 32px;
        &.active {
          background: $primary_text_color;
        }
      }
    }
    .tool-prop {
      height: 32px;
      .widget {
        height: 100%;
      }
      select {
        outline: none;
      }
      .selector {
        position: relative;
        .wrap-icon {
          position: absolute;
          right: 0;
          pointer-events: none;
        }
      }
      .wrap-color-picker {
        position: relative;
        .picker {
          position: absolute;
          right: 0;
          top: calc(100% + 4px);
          width: 300px;
          filter: $drop_shadow;
          z-index: 101;
        }
      }
    }
  }
}
</style>

<style lang="scss">
@import "@/scss/_variables.scss";

.wrap-item-tool-header {
  .v-color-picker__controls {
    display: none;
  }
  .v-color-picker__swatch {
    padding-bottom: 0;
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    slide: {
      type: Object,
      required: true
    },
    currentTool: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      tools: [
        { type: 'select', icon: 'mdi-cursor-default', size: 16 },
        { type: 'text', icon: 'mdi-format-text', size: 20 },
        { type: 'image', icon: 'mdi-image', size: 20 }
      ],
      fontSize: 20,
      fontWeight: 'normal',
      fontFamily: 'Yu Gothic',
      color: '#999999',
      backgroundColor: '#00000000',
      swatches: [
        ['#000000', '#999999', '#FFFFFF'],
        ['#56c1ff', '#2976ba', '#184d80'],
        ['#88fb50', '#60d837', '#41b101'],
        ['#fdf057', '#fbd933', '#f7ae04'],
        ['#f5978d', '#f3634e', '#ee230d']
        // ['#f595ca', '#f243a1', '#d41976']
      ],
      bgSwatches: [
        ['#000000', '#999999', '#FFFFFF', '#00000000'],
        ['#56c1ff', '#2976ba', '#184d80'],
        ['#88fb50', '#60d837', '#41b101'],
        ['#fdf057', '#fbd933', '#f7ae04'],
        ['#f5978d', '#f3634e', '#ee230d']
        // ['#f595ca', '#f243a1', '#d41976']
      ],
      showColorPicker: false,
      showBgColorPicker: false,
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  watch: {
    fontSize () { this.setFontOption() },
    fontWeight () { this.setFontOption() },
    fontFamily () { this.setFontOption() },
    color () { this.setFontOption() },
    backgroundColor () { this.setFontOption() }
  },
  methods: {
    onToolIcon (tool) {
      this.$parent.isEditingDoodle = false
      this.$emit('setCurrentTool', tool.type)
    },
    getFontOption () {
      return {
        fontSize: this.fontSize,
        fontWeight: this.fontWeight,
        fontFamily: this.fontFamily,
        color: this.color,
        backgroundColor: this.backgroundColor
      }
    },
    setFontOption () {
      this.$emit('setFontOption')
    }
  }
}
</script>
